import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { CustomerCurrent } from '../data/customer';
import { UploadResponse } from '../data/file-upload-response.model';
import { SasResponse } from '../data/file-upload-sas-response';
import { FileList } from '../data/file-list.model';
import { Dealer, DealerCurrent } from '../data/dealer';

import { FileUploadService } from '../services/fileUpload.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  standalone: false
})
export class FileUploadComponent {

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  selectedYear: string = "";

  selectedFile: File | null = null;
  ref: any;
  fleet: boolean = false;
  dlr: boolean = false;
  dealer: Dealer = DealerCurrent;

  username = "";


  yearsList: any[] = [];
  allYears: string[] = [];
  filesByYear: Record<string, FileList[]> = {};
  selectedYears: string[] = [];
  loading = false;

  uploadResult?: UploadResponse;

  sasReponse?: SasResponse;

  errormsg: string = "";
  msg: string = "";
  progress: any;

  constructor(
    private funcs: FuncsService,
    private route: ActivatedRoute,
    private uploadService: FileUploadService
  ) { }

  ngOnInit() {
    this.msg = "";
    this.errormsg = "";

    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      } else if (this.ref == "dealer") {
        this.dlr = true;
      }
    });

    if (this.ref == "fleet" || CustomerCurrent.role === "FLEET") {
      this.fleet = true;
    } else if (this.ref == "dealer" || CustomerCurrent.role == "DEALER" || CustomerCurrent.role == "INT_DEALER") {
      this.dlr = true;
    }

    if (this.fleet || this.dlr) {
      this.funcs.currentDealer(this.dealer);
      this.username = this.getUsername(this.dealer.pa_code);
    } else {
      this.funcs.checkAdmin();
      this.funcs.currentCustomer(CustomerCurrent);
      this.username = CustomerCurrent.username;
    }

    var now = new Date();

    this.yearsList.push({ year: now.getFullYear() }, { year: now.getFullYear() - 1 });
    this.selectedYear = now.getFullYear().toString();

    this.getUserYearsFromBlob();
  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else if (this.dlr) {
      username = `FCT${pa_code}`
    }

    return username;
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  uploadFile() {
    this.msg = "";
    this.errormsg = "";
    const file = this.selectedFile;

    if (!file) {
      this.errormsg = "Choose a file!";
      return;
    }

    this.uploadService.generateSas(this.username, file.name, this.selectedYear).subscribe({
      next: (sas) => {
        this.uploadService.uploadWithProgress(sas.sasUrl, file).subscribe({
          next: (event) => {
            if (event.type === HttpEventType.UploadProgress && event.total) {
              this.progress = Math.round(100 * event.loaded / event.total);
            }

            if (event.type === HttpEventType.Response) {
              this.msg = 'Upload Completed.';
              this.fileInput.nativeElement.value = '';
              this.selectedFile = null;
              this.getUserYearsFromBlob();
            }
          },
          error: err => {
            this.errormsg = 'Upload failed: ' + err;
          }
        });
      },
      error: err => {
        this.errormsg = 'Sas error', err;
      }
    });

    // this.uploadService.uploadFile(this.selectedFile, this.selectedYear, CustomerCurrent.username)
    //   .subscribe({
    //     next: (response: UploadResponse) => {
    //       this.uploadResult = response;

    //       if (response.success) {
    //         this.msg = 'File uploaded to:' + response.blobUri;
    //       } else {
    //         this.msg = 'Upload failed:' + response.errorMessage;
    //       }
    //     },
    //     error: (err: UploadResponse) => {
    //       this.uploadResult = err;
    //       this.errormsg = 'Upload failed:', err.errorMessage;
    //     }
    //   });
  }

  getUserYearsFromBlob() {
    this.uploadService.getUserYears(this.username).subscribe({
      next: (years) => {
        this.allYears = years;
      },
      error: err => {
        this.errormsg = "Unable to fetch years.", err;
      }
    });
  }

  dateFormat(dateString: string): string {
    return this.funcs.dateFormat(dateString);
  }

  toggleYear(year: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedYears.push(year);
      this.listFiles(year);
    } else {
      this.selectedYears = this.selectedYears.filter(y => y !== year);
      delete this.filesByYear[year];
    }
  }

  listFiles(year: string) {
    if (this.filesByYear[year]) return;

    this.loading = true;

    this.uploadService.getFiles(this.username, year).subscribe(files => {
      this.filesByYear[year] = files;
      this.loading = false;
    });
  }

  viewFile(fileName: string) {
    this.uploadService.viewFile(fileName).subscribe(sas => {
      window.open(sas.sasUrl, '_blank');
    });
  }

}
